export default "__VITE_ASSET__DcJceOfm__"